export class User {
	companyName: string = '';
	cvr: string = '';
	email: string = '';
	fqn: string = '';
	id: string = '';
	idp: string = '';
	personName: string = '';
	username: string = '';
}